function price(amount: number) {
  const formattedAmount = amount.toFixed(2);

  return `CHF ${formattedAmount}`;
}

export default price;
